import script from "./Employees.vue?vue&type=script&setup=true&lang=js"
export * from "./Employees.vue?vue&type=script&setup=true&lang=js"

import "./Employees.vue?vue&type=style&index=0&id=13c9b7e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13c9b7e8"]])

export default __exports__